<header class="title-header pt-7 flex items-center justify-between">
  <div class="title-content flex items-center gap-2">
    <span class="material-symbols-outlined title-icon">orders</span>
    <h1 class="title-text">Ordenes de compra</h1>
  </div>
  <!--Agregar ordenes-->
  <button class="add-button-top" (click)="openModal()">
    + Agregar orden
  </button>
</header>

<!--Subheader-->
<div class="mt-4 flex flex-wrap items-center justify-between bg-gray-50 p-3 rounded-lg shadow-sm">
  <p class="sub-heading-2">
    Total: {{ orders.length }} Ordenes de compra
  </p>
<!--Controles de filtros-->
</div>

<!--Modal de filtros-->
<!--Filtros activos-->

<!--Tabla de muestra de archivos-->

<section class="p-6">
  <table class="w-full border-collapse bg-white rounded-xl shadow">
    <thead class="bg-gray-100 text-gray-900 text-sm">
      <tr>
        <th class="text-left py-3 px-4">Orden</th>
        <th class="text-left py-3 px-4">Estatus</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let o of orders" class="hover:bg-gray-50">
        <td class="py-3 px-4">{{o.fileName}}</td>
        <td class="py-3 px-4">{{o.fileStatus}}</td>
      </tr>
      <tr *ngIf="orders.length === 0">
        <td colspan="2" class="text-center py-6 text-gray-400">
          No hay ordenes cargadas.
        </td>
      </tr>
    </tbody>
  </table>
</section>

<!--Modal para subir archivos-->
<app-upload-purchase-order-modal *ngIf="showModal" (close)="closeModal()" (fileUploaded)="handleFilesUpload($event)"></app-upload-purchase-order-modal>
